import React from 'react'
import classes from './Spinner.css'

const Spinner = props => (
  <div className={classes.center}>
    <div className={classes.Spinner}>
      <div />
      <div />
    </div>
  </div>
)

export default Spinner
